import { Image, StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';
import layout from '../../../assets/layout_report.png';
import Footer from './Footer';
import Header from './Header';
import { EDULAI_BLUE, EDULAI_ORANGE, EDULAI_PURPLE } from '../../../styles/styleConsts';
import translations from '../../../translations/i18next';
import ReportText from './ReportText';
import strenghtImage from '../../../assets/strengths.png';
import weaknessImage from '../../../assets/weaknesses.png';
import ReportTextHtml from './ReportTextHtml';

const styles = StyleSheet.create({
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 1
  },
  text: {
    fontSize: 10,
    marginBottom: 5,
    color: EDULAI_PURPLE
  },
  section: {
    flex: 1,
    margin: 10,
    fontSize: 12,
    borderRadius: 8
  },
  leftHeader: {
    fontSize: 16,
    fontWeight: 'bold',
    marginVertical: 8,
    color: EDULAI_ORANGE,
    alignSelf: 'center'
  },
  rightHeader: {
    fontSize: 16,
    fontWeight: 'bold',
    marginVertical: 8,
    color: EDULAI_BLUE,
    alignSelf: 'center'
  },
  leftBackgroundContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: '#f57d24',
    opacity: 0.12,
    borderRadius: 8
  },
  rightBackgroundContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: '#4d66b9',
    opacity: 0.08,
    borderRadius: 8
  }
});

const Chart = ({ user, chart, data }) => {
  return (
    <>
      <Image style={styles.backgroundImage} src={layout} fixed />
      <Header user={user} />
      <ReportText style={{ marginTop: 5, color: EDULAI_BLUE, fontSize: 14, fontWeight: 'bold' }}>
        {translations.t('skillsReport.skillsChartResultsTitle')}
      </ReportText>
      <View style={{ marginTop: 20 }}>
        <Image src={chart} />
      </View>
      <View style={{ marginTop: 30 }}>
        <ReportTextHtml style={styles.text}>{data.description}</ReportTextHtml>
      </View>

      <View
        style={{ paddingHorizontal: 20, paddingTop: 10, display: 'flex', flexDirection: 'row' }}
        minPresenceAhead={60}
        break
      >
        <View style={styles.section}>
          <View style={styles.leftBackgroundContainer} />
          <View style={{ paddingVertical: 15, paddingHorizontal: 10 }}>
            <Image src={strenghtImage} style={{ height: 40, alignSelf: 'center' }} />
            <ReportText style={styles.leftHeader}>{translations.t(`skillsReport.strengths`)}</ReportText>
            <ReportTextHtml style={styles.text}>{data.strengths}</ReportTextHtml>
          </View>
        </View>

        <View style={styles.section}>
          <View style={styles.rightBackgroundContainer} />
          <View style={{ paddingVertical: 15, paddingHorizontal: 10 }}>
            <Image src={weaknessImage} style={{ height: 40, alignSelf: 'center' }} />
            <ReportText style={styles.rightHeader}>{translations.t(`skillsReport.weaknesses`)}</ReportText>
            <ReportTextHtml style={styles.text}>{data.mediumWeaknesses}</ReportTextHtml>
            <ReportTextHtml style={styles.text}>{data.lowWeaknesses}</ReportTextHtml>
          </View>
        </View>
      </View>
      <Footer />
    </>
  );
};

export default Chart;
